import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import { GapNote, helperProps, compactPlaceholderSx } from './common'
import { useTransferOwnershipMutation } from '../../../redux/d2cApiSlice'

/** TransferOwnershipDialog — FH-only: reassign a proposal's owner (PUT /admin/proposals/{id}/transfer). */
export default function TransferOwnershipDialog({ open, onClose, proposalId, brand }) {
  const { enqueueSnackbar } = useSnackbar()
  const [transfer, state] = useTransferOwnershipMutation()
  const [newOwnerId, setNewOwnerId] = useState('')
  const [reason, setReason] = useState('')
  const [ownerErr, setOwnerErr] = useState(false)

  const submit = async () => {
    if (!newOwnerId.trim()) { setOwnerErr(true); return }
    if (state.isLoading) return
    try {
      await transfer({ proposalId, body: { newOwnerId: newOwnerId.trim(), reason: reason || undefined } }).unwrap()
      enqueueSnackbar('Ownership transferred.', { variant: 'success' })
      setOwnerErr(false)
      setNewOwnerId(''); setReason('')
      onClose && onClose()
    } catch (e) { enqueueSnackbar(e?.message || 'Transfer failed.', { variant: 'error' }) }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth sx={compactPlaceholderSx}>
      <DialogTitle sx={{ fontSize: 15, fontWeight: 700, color: 'primary.dark' }}>Transfer ownership{brand ? ` — ${brand}` : ''}</DialogTitle>
      <DialogContent dividers>
        <GapNote id="transfer_owner_id" />
        <TextField
          fullWidth
          required
          size="small"
          label="New owner — user ID"
          value={newOwnerId}
          onChange={(e) => { setOwnerErr(false); setNewOwnerId(e.target.value) }}
          error={ownerErr && !newOwnerId.trim()}
          {...helperProps(ownerErr && !newOwnerId.trim() ? 'New owner — user ID is required.' : undefined)}
          sx={{ mb: 1.5 }}
          placeholder="e.g. user_sl_007"
        />
        <TextField fullWidth multiline minRows={2} size="small" label="Reason (optional, audit)" value={reason} onChange={(e) => setReason(e.target.value)} />
        {!proposalId && <Typography sx={{ fontSize: 12, color: 'error.main', mt: 1 }}>No proposal selected.</Typography>}
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 1.5 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>Cancel</Button>
        <Button variant="contained" disabled={!proposalId || state.isLoading} onClick={submit} sx={{ textTransform: 'none' }}>
          {state.isLoading ? 'Transferring…' : 'Transfer'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
